import React from "react";
import AccessibilityChatRoom from "@/components/AccessibilityChatRoom";
import { useSeo } from "@/lib/useSeo";

/**
 * Dedicated full-page chat for the whole student community.
 * Reuses the AccessibilityChatRoom component (same anonymous/moderated chat infra).
 */
export default function ChatCommunaute() {
  useSeo({
    title: "Chat communauté étudiante — Student Hub",
    description: "Échange en temps réel avec d'autres étudiant·e·s en France. Chat anonyme, pseudo et avatar, modération bienveillante.",
    keywords: "chat étudiant France, communauté étudiante, entraide étudiants, forum étudiant anonyme",
  });
  return (
    <div className="space-y-6" data-testid="chat-communaute-page">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-violet-700 font-semibold mb-2">Espace communauté</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Chat communauté étudiante</h1>
        <p className="text-slate-600 mt-2 max-w-2xl">Un espace bienveillant pour échanger avec d'autres étudiant·e·s en France. Anonyme, modéré, avec pseudo et avatar.</p>
      </header>
      <AccessibilityChatRoom />
    </div>
  );
}
